export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.5 4a3 3 0 013 3v10a3 3 0 01-3 3h-15a3 3 0 01-3-3V7a3 3 0 013-3h15zm-16 6.5V17a1 1 0 001 1h15a1 1 0 001-1v-6.5h-17zm1-4.5a1 1 0 00-1 1v1.5h17V7a1 1 0 00-1-1h-15z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};